import { queryOptions, useQuery } from '@tanstack/react-query';
import { generateListResponseScheme, type ListRespondedWith } from '@/models/response';
import { type TagMember, tagMemberScheme } from '@/models/user/tag';
import { fetcher } from '@/utils/fetcher';

export const generateTagMemberQueryOptions = (tagId: number) =>
  queryOptions({
    queryKey: [`/GetTagMembers/${tagId}`],
    queryFn: ({ signal }) =>
      fetcher<ListRespondedWith<TagMember>>(
        '/GetTagMembers',
        { TagID: tagId },
        { signal, schema: generateListResponseScheme(tagMemberScheme), validResponseCodes: [0, 1] },
      ).then((response) => response?.Data ?? []),
    placeholderData: [] as TagMember[],
  });

export default function useTagMembers(tagId: number) {
  const query = useQuery(generateTagMemberQueryOptions(tagId));

  return {
    tagMembers: query.data ?? [],
    ...query,
  };
}
